module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      ready: _vm.ready
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "flipLoading",
    attrs: {
      "id": "cover"
    }
  }, [_c('svg', {
    attrs: {
      "id": "logo",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 160 160"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "Rectangle",
      "x": "1",
      "y": "4",
      "width": "158",
      "height": "158",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feOffset', {
    attrs: {
      "dy": "3",
      "input": "SourceAlpha"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "3",
      "result": "blur"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-opacity": "0.161"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "operator": "in",
      "in2": "blur"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip"
    }
  }, [_c('rect', {
    attrs: {
      "width": "160",
      "height": "160"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-1"
  }, [_c('rect', {
    staticClass: "cls-7",
    attrs: {
      "width": "160",
      "height": "160"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group_349",
      "data-name": "Group 349",
      "transform": "translate(-163 -414)"
    }
  }, [_c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ready),
      expression: "!ready"
    }],
    staticClass: "cls-8",
    attrs: {
      "transform": "matrix(1, 0, 0, 1, 163, 414)"
    }
  }, [_c('g', {
    staticClass: "cls-2",
    attrs: {
      "transform": "translate(10 10)"
    }
  }, [_c('rect', {
    staticClass: "cls-5",
    attrs: {
      "width": "140",
      "height": "140",
      "rx": "3"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-6",
    attrs: {
      "x": "1.5",
      "y": "1.5",
      "width": "137",
      "height": "137",
      "rx": "1.5"
    }
  })])]), _vm._v(" "), _c('text', {
    staticClass: "cls-3",
    attrs: {
      "id": "Hacking",
      "transform": "translate(243 503)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-54.719",
      "y": "0"
    }
  }, [_vm._v("Hacking")])]), _vm._v(" "), _c('text', {
    staticClass: "cls-4",
    attrs: {
      "id": "Map",
      "transform": "translate(216 539)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "0",
      "y": "0"
    }
  }, [_vm._v("Map")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bcebef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 970
// module chunks = 1